const KRW_GROUPING = new Intl.NumberFormat('ko-KR');
export function formatKrw(amount) {
    if (!Number.isFinite(amount))
        return '-';
    return `${KRW_GROUPING.format(amount)}원`;
}
//# sourceMappingURL=format-krw.js.map